import {
    useEffect,
    useState,
} from 'react';

import {Autocomplete,} from '@mantine/core';

import {useApplications} from '../hooks/useApplications';
import {Application} from '../types';
import {FieldProps} from 'formik';

export const ApplicationsAutocomplete = ({
                                             field: {
                                                 name,
                                                 value: fieldValue,
                                             },
                                             form: {setFieldValue},
                                             ...rest
                                         }: FieldProps) => {

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(false);

    const {items: records} = useApplications();

    const data = records.map((record: Application) => {
        return {
            ...record,
            label: record.name || '',
            value: record.name || '',
        };
    });


    useEffect(() => {
        if (records.length === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }

        const found = records.find((item: Application) => item.id === fieldValue);
        if (typeof found !== 'undefined' && Object.prototype.hasOwnProperty.call(found, 'name')) {
            setValue(found.name as string);
        }
    }, [records.length]);

    const handleChange = (value: string) => {
        if (!Array.isArray(data)) {
            throw new Error('Data is expected to be an array');
        }
        const {id} = data.find((item) => item.name === value) || {};

        if (typeof id !== 'undefined') {
            setFieldValue(name, id);
        }

        setValue(value);
    };

    return (
        <Autocomplete
            name={name}
            value={value}
            onChange={handleChange}
            data={data}
            disabled={disabled}
            placeholder='Select Application'
            {...rest}
        />
    );
};
